
import SharePage from '@/components/share/SharePage';
import { shareTabConstant } from '@/constants/share';

export default {
    components: { SharePage },
    async asyncData({ params }) {     
        return {
            fundamentalTabId: params.tab_id
        };
    },

    created() {
        this.shareTabConstant = shareTabConstant;
    }
}
